import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';

class ModuleEnrolmentDeleteDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
    }

    render() {
        const dialogProps = {
            title:          "Delete Enrolment",
            open:           true,
            modal:          true,
            onRequestClose: this.props.onClose,
            actions: [
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton key="delete" label="Delete" onTouchTap={this.onSave}/>
            ]
        };

        return (
            <Dialog {...dialogProps} >
                Are you sure you wish to delete this enrolment?
            </Dialog>
        );
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }
}

ModuleEnrolmentDeleteDialog.getStores = () => ([DialogStore]);
ModuleEnrolmentDeleteDialog.calculateState = () => {
    const {open, draft} = DialogStore.getState();
    return {
        open,
        draft,
    };
};
ModuleEnrolmentDeleteDialog.propTypes = {
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};

ModuleEnrolmentDeleteDialog.defaultProps = {
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(ModuleEnrolmentDeleteDialog);
